import Image from "next/image";
import CommonImage from "@/components/common/image/CommonImage";
import Link from "next/link";
export default function BlogCard({ blog }) {
    return (
  
             <div className="blog-card">
                    <Link href={`/blogs/${blog?.slug}`}  className="blog-image">
                      <CommonImage
                        src={blog?.thumbnail_url??"/images/instructor/blog-size.avif"}
                        className="img-icon"
                        alt={"Image"}
                      />
                    </Link>
                    <div className="blog-content">
                      <h2 className="title"><Link href={`/blogs/${blog?.slug}`} >{blog.title}</Link></h2>
                      <p className="date">{new Date(blog.created_at).toLocaleDateString('bn-BD', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                })} </p>
                    </div>
                  </div>
        
    );
}

